<template>
  <div class="hero-body">
    <div class="container has-text-centered">
      <div class="message">
        <h1 class="title">{{ nextStepsHeader }}</h1>
        <div class="message-body">
          <span v-html="nextSteps"></span>
        </div>
        <div
          class="next-steps-button"
          v-if="nextStepsButtonLabel && nextStepsButtonUrl"
        >
          <a
            class="button is-primary submit-button"
            target="_blank"
            :href="nextStepsButtonUrl"
            >{{ nextStepsButtonLabel }}</a
          >
        </div>
      </div>
      <contact></contact>
      <reset-button></reset-button>
    </div>
  </div>
</template>

<script>
import contact from "@/components/Contact";
import resetButton from "../components/questions/resetButton";
import { mapState } from "vuex";
import { sendInterviewCompleted } from "../helpers/iframe";

export default {
  name: "success",

  components: {
    contact,
    resetButton
  },
  computed: {
    ...mapState("interview", [
      "nextStepsHeader",
      "nextSteps",
      "nextStepsButtonLabel",
      "nextStepsButtonUrl"
    ])
  },
  mounted() {
    sendInterviewCompleted();
  }
};
</script>

<style lang="scss" scoped>
.next-steps-button {
  width: initial;
  display: inline-block;
}
</style>
